import { createFileRoute } from '@tanstack/react-router'
import { StaffPembangunan } from '../../../../components/StaffPembangunan'

export const Route = createFileRoute('/platform/desa/$desaId/pembangunan')({
  component: () => {
    const { desaId } = Route.useParams()
    return <StaffPembangunan desaId={desaId} />
  },
})
